import store from '&/store';
import * as types from '&/store/constants/types';

export default error => {
	if (process.env.NODE_ENV !== 'production') {
		console.error(error);
	}

	return store.dispatch({
		type: types.app.ERROR,
		payload: {
			error,
		},
	});
};
